import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NavbarVIP = ({ currentUser }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("currentUser");
    navigate("/login");
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Container fluid className="px-4">
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-between">
          <Nav>
            {/* <Nav.Link onClick={() => navigate("/vip/dashboard")}>Dashboard</Nav.Link>
            <Nav.Link onClick={() => navigate("/vip/reports")}>Reports</Nav.Link> */}
            {/* <Nav.Link onClick={() => navigate("/vip/data")}>API Data</Nav.Link> */}
          </Nav>
          <Nav className="align-items-center">
            {currentUser && (
              <span className="text-light me-3">
                Welcome, {currentUser.username}
              </span>
            )}

            <Button
              variant="outline-light"
              className="me-3"
              onClick={() => navigate("/vip/dashboard")}
            >
                Home
            </Button>

            <Button variant="outline-light" onClick={handleLogout}>
              Logout
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarVIP;
